// ============================================================
//  src/public-profile.js — Snapshot público de perfil
//  Escribe y borra documentos en publicProfiles/{CALLSIGN}
// ============================================================

import { doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase.js';
import { calcularResumenPerfil } from './dashboard-profile-card.js';
import { logInfo } from './core/logger.js';
import { manejarError } from './core/errors.js';

// ============================================================
//  Normalización
// ============================================================

function normalizarCallsign(valor) {
  return (valor ?? '').trim().toUpperCase();
}

// ============================================================
//  Escritura del snapshot
// ============================================================

export async function actualizarPerfilPublico(uid, perfil, ediciones = [], callsignAnterior = null) {
  if (!uid || !perfil) return;

  const callsign = normalizarCallsign(perfil.indicativoOperador);
  if (!callsign) return;

  const anteriorNorm = normalizarCallsign(callsignAnterior);
  if (anteriorNorm && anteriorNorm !== callsign) {
    await eliminarPerfilPublico(anteriorNorm);
  }

  try {
    const resumen = calcularResumenPerfil(ediciones, perfil);

    // Privacidad: vaciar campos según preferencia del usuario.
    // Si el campo no existe en el perfil (doc viejo), se trata como true.
    const resumenTarjeta = {
      ...resumen,
      identidad: {
        ...resumen.identidad,
        telefono:          perfil.mostrarTelefonoPublico !== false ? resumen.identidad.telefono : '',
        correoElectronico: perfil.mostrarEmailPublico    !== false ? resumen.identidad.correoElectronico : '',
      },
    };

    const datos = {
      callsign,
      userId: uid,
      resumenTarjeta,
      tema: perfil.preferencias?.tema ?? 'oscuro',
      idioma: perfil.preferencias?.idioma ?? 'es',
      actualizadoEn: serverTimestamp(),
    };

    const ref = doc(db, 'publicProfiles', callsign);
    await setDoc(ref, datos);

    logInfo('PublicProfile', `Snapshot actualizado: ${callsign}`);
  } catch (error) {
    manejarError(error, 'PublicProfile actualizar', { mostrar: false });
  }
}

// ============================================================
//  Borrado del snapshot
// ============================================================

export async function eliminarPerfilPublico(callsign) {
  const cs = normalizarCallsign(callsign);
  if (!cs) return;

  try {
    const ref = doc(db, 'publicProfiles', cs);
    await deleteDoc(ref);
    logInfo('PublicProfile', `Snapshot eliminado: ${cs}`);
  } catch (error) {
    manejarError(error, 'PublicProfile eliminar', { mostrar: false });
  }
}
